import React from 'react';
import { Link } from 'react-router-dom';
import { LuCircleX, LuRefreshCw } from 'react-icons/lu';
import XiLogo from '../components/ui/XiLogo';

/**
 * Payment cancelled / failed result screen.
 *
 * No `/checkout` route exists — retry returns to the real checkout surface
 * (PricingSection on Home, or Get Started when signed out) instead of a dead
 * link. This behaviour is preserved from the original implementation.
 */
const PaymentCancel = () => {
  const retryTarget =
    typeof window !== 'undefined' && localStorage.getItem('neuro_user_id')
      ? '/'
      : '/getStarted';

  return (
    <div className="xi-public xi-result">
      <div className="xi-public__veil" aria-hidden="true" />
      <div className="xi-public__body xi-result__body">
        <div className="xi-enroll__brand">
          <XiLogo size="sm" tagline />
        </div>

        <div className="xi-auth-card xi-result__card" role="alert">
          <span className="xi-result__icon is-bad" aria-hidden="true">
            <LuCircleX />
          </span>
          <span className="xi-eyebrow">Payment not completed</span>
          <h1>Payment failed or cancelled</h1>
          <p className="xi-muted">
            Your payment was not completed. Please try again.
          </p>

          <div className="xi-result__actions">
            <Link to={retryTarget} className="xi-btn xi-btn--primary xi-btn--lg">
              <LuRefreshCw aria-hidden="true" />
              Retry payment
            </Link>
          </div>

          <p className="xi-enroll__note">
            Need help? Contact our support team for assistance.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
